import React from 'react';
import { TextValidator } from 'react-material-ui-form-validator';
//import Multiline from "./Multiline";
import HiddenInput from "./HiddenInput";
import {
    GRAY
   ,HIDE
} from "../../redux/constants";
import Autocomplete/*, { createFilterOptions }*/ from '@material-ui/lab/Autocomplete';
import {
    isObject
} from "../../redux/actions/utils";

//const _filter = createFilterOptions();
/*
Two states of Autocomplete: для правильной работы Autocomplete нужны оба состояния, одно будет с префиксом "xxcdoc_"
1) value/onChange() - selected value
2) inputValue/onInputChange() - displayed value in the textbox

props.list = [] - список
для двуязычных форм [ { id: Ru, name: En }, ... ]

через props можно передать функции, все необязательные:
props.onInputChange( value ) - реакция на печать в поле ввода
props.onSelectChange( value ) - выбор из списка
props.onNameValueChange( name, value ) - реакция на печать и на выбор из списка, для обновления value и inputValue в state (без неё Autocomplete бывает глючит)
props.onChange( e ) - чтобы можно было впечатать новое значение; без этого можно печатать, но любой текст не сохраняется, только выбор из списка
props.onFocus - для заполнения списка в момент обращения, используется в компоненте StartrekIntegration

readonly - только чтение, отрисовка полем Multiline
selectonly - можно выбрать из списка, нельзя ввести новое значение,
была идея отрисовать Select-ом, но тогда надо заполнять список, т.к. значения не из списка не отобразятся

!visible - значит поля нет, его значение не определено,
protect = hide - поле есть, но скрыто от внешнего пользователя

в двуязычном шаблоне при выбранном En языке list = [{ id: Ru, name: En }] и isLang
defaultValue и visibilityParentValue заданы по-русски, поле нужно отобразить на английском,
Select так и работает по умолчанию, а для InputWithSelect используем флаг isLang или isObject

Не определились с поведением
в двуязычном шаблоне при выбранном En языке.
Select [{ id: Ru, name: En }] возвращает id, то есть, Ru.
Наверное, это хорошо для условий if в документе и условий видимости на форме.
InputWithSelect ведёт себя то как Select, то как Input,
потому что можно впечатать новое значение от руки.
*/

const InputWithSelect = ( props ) => {
 
    if( !props.visible && props.visible !== undefined ) return;
    const value = props.value === undefined || props.value === null ? '' : props.value;

    const readonly = props.readonly || ( props.isExternal && props.protect === GRAY );
    const selectonly = props.selectonly;
    
    //if( readonly ) return <Multiline {...props} />; // так нельзя, потому что для языка En будет выведено значение Ru
    // вместо этого Autocomplete disabled и HiddenInput для отправки значения с формы
    const hiddenInput =
        <HiddenInput
            name = { props.name }
            value = { value }
        />;
        
    // protect для внешней формы
    if( props.isExternal && props.protect === HIDE )
    return hiddenInput;
    
    // How to select option by id or by name in Autocomplete Material-UI
    // https://stackoverflow.com/questions/66998083/how-to-select-option-by-id-or-by-name-in-autocomplete-material-ui
    /*const filterOptions = ( options, state ) => {
        const result = _filter( options, state );

        if( result.length === 0 ) {
            return _filter( options, {
                ...state
               ,getOptionLabel: o => o.id.toString()
            });
        }

        return result;
    };*/

    const list = props.list;
    const isLang = props.isLang;
    const isComplex = isLang || ( list && isObject( list[0] ) );
    
    const complexValue = id => {
        let value = id;
        if( isComplex && Array.isArray( list ) ) {
            const index = list.findIndex( i => i.id === id ); // что если типы id и value не совпали?
            if( index > -1 ) value = list[ index ];
        }
        return value;
    };
    
    /*const translateToLang = id => {
        // для двуязычных форм при выбранном языке En
        // value = Ru, list = [{ id: Ru, name: En }], находим name по id
        let value = id;
        if( isLang && Array.isArray( list ) ) {
            const index = list.findIndex( i => i.id === id ); // что если типы id и value не совпали?
            if( index > -1 ) value = list[ index ].name.toString();
        }
        return value;
    };*/
    
    /*
    // обычный Select возвращает id,
    // в InputWithSelect нужно такое же поведение,
    // когда в Админке выбираем defaultValue для InputWithSelect
    const translateFromLang = value => {
        // для двуязычных форм при выбранном языке En
        // value = En, list = [{ id: Ru, name: En }], находим id по name
        let id = value;
        if( isLang && Array.isArray( list ) ) {
            const index = list.findIndex( i => i.name === value ); // что если типы name и value не совпали?
            if( index > -1 ) id = list[ index ].id.toString();
        }
        return id;
    };*/
    
    // замена props.onChange для двуязычных форм
    const onBlur = e => {
        
        //e.target.value = translateFromLang( e.target.value );
        
        if( typeof props.onChange === "function" ) props.onChange( e );
    };
    
    
    return (

        <div className='padding'>
            { readonly && hiddenInput }
            <Autocomplete
                value={ complexValue( value ) }
                disabled={ readonly }
                onChange={ ( event, newValue ) => { // newValue может быть записью

                    // если строка (значение из обычного списка) - вернуть строку
                    // если запись { id: Ru, name: En } (значение из двуязычного списка) - вернуть id
                    // если другая запись, например, выбор пользователя на странице Роли, или селектор группы / шаблона - вернуть запись целиком
                
                    // если двуязычная форма и выбран En язык, то будет запись формата { id: Ru, name: En } и флаг isLang
                    // если язык Ru, то просто список значений
                
                    // для двуязычных форм
                    // если newValue = запись { id: Ru, name: En }
                    if( isLang && newValue && newValue.id !== undefined ) newValue = newValue.id; // id может быть string и number

                    if( typeof props.onNameValueChange === "function" ) props.onNameValueChange( props.name, newValue );
                    if( typeof props.onSelectChange === "function" ) props.onSelectChange( newValue );
                }}
                
                inputValue = { props[ 'xxcdoc_' + props.name ] }
                onInputChange={(event, newValue) => {

                    if( typeof props.onNameValueChange === "function" ) props.onNameValueChange( 'xxcdoc_' + props.name, newValue );
                    if( typeof props.onInputChange === "function" ) props.onInputChange( newValue );
                }}
        
                className={ props.className }
                options={ list ? list : [] }
                groupBy={ props.groupBy }
                
                // значения в выпадающем списке
                renderOption={ option => {
                    if( option === undefined || option === null ) {
                        return '';
                    }
                    if( typeof option === 'string' ) {
                        return option;
                    }
                    if( option.name !== undefined && option.name !== null ) {
                        return option.name;
                    }
                    return option;
                }}
                onFocus={ props.onFocus } // для заполнения списка в момент обращения, используется в компоненте StartrekIntegration

                //filterOptions={ filterOptions }
      
                // чтобы писал "Add <new value>" при добавлении нового значения, не из списка
                /*filterOptions={(options, params) => {
                 
                    const filtered = filter( options, params );

                    if (params.inputValue !== '') {
                        filtered.push({
                            inputValue: params.inputValue,
                            name: `Add "${params.inputValue}"`,
                        });
                    }
                    
                    return filtered;
                }}*/
                
                // значения в поле Input
                // кастомизация используется в RoleForm
                getOptionLabel={ option => {
                
                    if( option === undefined || option === null ) {
                        return '';
                    }
                    if( typeof option === 'string' ) {
                        return option;
                    }
                    if( option.inputValue !== undefined && option.inputValue !== null ) {
                        return option.inputValue;
                    }
                    if( option.name !== undefined && option.name !== null ) {
                        return option.name;
                    }
                    return option; // MUI хочет, чтобы здесь был только string
                }}

                renderInput={ params => (
                    <TextValidator
                        { ...params }
                        multiline
                        label = { props.label }
                        name = { props.name }
                        value = { value } // значение поля уйдёт в form submit
                        InputLabelProps = {{ shrink: !!params.inputProps.value }} // поднять label над полем, иначе может наехать на значение
                        InputProps={{
                            ...params.InputProps
                           ,readOnly: selectonly || readonly
                           ,className: selectonly || readonly ? 'Mui-disabled' : 'MuiAutocomplete-inputRoot'
                        }}
                        // disabled = { selectonly } // disabled поля не попадают в submit form
                        onBlur={ onBlur } // было onBlur={ props.onChange }
                        validators = { props.validators }
                        errorMessages = { props.errorMessages }
                        helperText={ props.helperText }
                        variant = { props.variant }
                        placeholder={ props.placeholder }
                    />
                )}
            />
        </div>
    );
}

export default InputWithSelect
